import { WatchQueryFetchPolicy } from '@apollo/client';
import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { ObjectType, useListMetadataKeysQuery } from 'generated/graphql';
import { apolloStatusToQueryStatus } from 'v2/core/repository/edge-server/statusConvertor';
import { IsLoading } from 'v2/core/repository/edge-server/types';
import { useGetUser } from 'v2/core/services/user';

interface useFetchMetadataDetailsForEqlSourceProps {
  eqlSource: string;
  fetchPolicy?: WatchQueryFetchPolicy;
  objectType?: ObjectType;
}

export const useFetchMetadataDetailsForEqlSource = ({
  eqlSource,
  fetchPolicy = 'cache-and-network',
  objectType,
}: useFetchMetadataDetailsForEqlSourceProps) => {
  const {
    tenant: { id: tenantID },
  } = useGetUser();

  const { showErrorNotification } = useNotificationContext();

  const { data, error, loading, called, refetch } = useListMetadataKeysQuery({
    skip: !eqlSource,
    variables: {
      tenantID,
      filter: {
        namespacedSources: [eqlSource],
        objectTypes: objectType ? [objectType] : undefined,
      },
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy,
    onError: () => {
      showErrorNotification({
        contentComponent: 'Failed to fetch metadata details.',
        props: {},
      });
    },
  });

  const status = apolloStatusToQueryStatus(loading, called, false, error);

  return {
    metadataDetails: data?.listMetadataKeys?.keys ?? [],
    error,
    isLoading: IsLoading(status),
    status,
    refetch,
  };
};
